import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { GroupsPage } from "@/features/domain/components/groups-page";
import { useI18n } from "@/providers/i18n-provider";

function GroupsRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Groups`)}
      description={t(msg`Sign in to manage groups, their types and their members.`)}
    >
      <PageContainer maxWidth="3xl">
        <GroupsPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const groupsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/groups",
  component: GroupsRoutePage,
});
